import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

const text = css`
  color: ${colors.gray.default};
  padding-left: 10px;
  display: inline-flex;
  font-weight: ${fonts.weight.bold};
`;

const box = css`
  height: 100%;
  margin-top: 10px;
`;

export default {
  text,
  box,
};
